/* eslint-disable function-paren-newline */
/* eslint-disable indent */

export class MasterMatrixController {

	/**
	 * @param {import('extensions/multi-system/types').MasterMatrix} matrix
	 * @param {import('lit').LitElement} [host]
	 */
	constructor (matrix, host) {
		(this.host = host)?.addController(this);

		/**
		 * @type {import('extensions/multi-system/types').MasterMatrix}
		 */
		this.matrix = matrix;
	}

	/**
	 * @param {number} roomCount
	 */
	determineMatrixType (roomCount) {
		if (roomCount <= 4) {
			return 'R32';
		}

		return 'R410A';
	}

	/**
	 * Input an array of current selections and output the available capcity classes from the given matrix.
	 * @param {string[][]} selections
	 * @param {number} roomIndex
	 * @param {number} roomCount
	 */
	getAvailableCapacityClasses (selections, roomIndex, roomCount) {
		// Get rows that match the current number of rooms and get a list of classes for the given index
		return this.matrix[this.determineMatrixType(roomCount)]
			?.map(matrixRow => matrixRow.filter(matrixValue => matrixValue !== '0'))
			?.filter(matrixRow => matrixRow.length === roomCount && selections.every((_selection, i) => !_selection || _selection.includes(matrixRow[i])))
			?.reduce((availableCapacityClasses, matrixRow) => availableCapacityClasses.concat([matrixRow[roomIndex]]), []);
	}
};
